import React, { ReactNode } from 'react';
import { Flex, FlexProps } from '@chakra-ui/react';

interface ToolbarProps extends FlexProps {
  children: ReactNode;
}

export const Toolbar = ({ children, ...rest }: ToolbarProps) => (
  <Flex
    align="center"
    flexWrap="wrap"
    gap="8px"
    p="12px"
    borderBottom="1px solid"
    borderColor="line.hairline"
    {...rest}
  >
    {children}
  </Flex>
);
